import { APP_VERSION } from "../../version";

export default function Footer() {
    return (
        <div className="text-center op-7">© ShedPaper 2025 | {<APP_VERSION />}</div>
    )
}